import { render, staticRenderFns } from "./allocate.vue?vue&type=template&id=2b8b9bcf&scoped=true"
import script from "./allocate.vue?vue&type=script&lang=js"
export * from "./allocate.vue?vue&type=script&lang=js"
import style0 from "./allocate.vue?vue&type=style&index=0&id=2b8b9bcf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b9bcf",
  null
  
)

export default component.exports